import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { confirmTokensRevoke } from '../actions';

const DisableTokensAction = ({
  category,
  onClick,
  disabled,
}) => (
  <RibbonMenu
    name="expire"
    icon="wait"
    message="actions.expire"
    onClick={() => onClick(category)}
    className="aridhia-disable-tokens-action"
    disabled={disabled}
  />
);

const mapStateToProps = ({
  tokens: { tokens },
}, { category }) => {
  const { readStatus } = tokens[category];
  const selected = findSelectedInCategory(tokens, category);
  const denyDisable = selected.some((token) => !token.active);

  return ({
    disabled: denyDisable || readStatus === states.PENDING || selected.length === 0,
  });
};

const mapDispatchToProps = {
  onClick: confirmTokensRevoke,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisableTokensAction);
